var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{directives:[{name:"b-popover",rawName:"v-b-popover.hover",value:(_vm.hover),expression:"hover",modifiers:{"hover":true}}],attrs:{"variant":_vm.variant(_vm.status)}},[_vm._v("\n    "+_vm._s(_vm._f("titleize")(_vm.status))+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132e63f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/components/sales-order/view-order-2/WebStatus.vue
// module id = null
// module chunks = 